module.exports = __webpack_public_path__ + "static/PPPoE.1078cc24.jpg";